import React from "react";
import { ResponsiveBar } from "@nivo/bar";

import { useTranslation } from "react-i18next";
import NoDataIcon from "../../../../assets/svg/no-data.svg";

const customGenColors = {
  FEMALE: "#3BBEE8",
  MALE: "#004877",
  Others: "#D3D3D3"
};
const AgeVsGenderChart = ({ isDataAvailable, graphData }) => {
  const { t } = useTranslation();
  const theme = {
    axis: {
      ticks: {
        text: {
          fontSize: 11,
          fill: `var(--stat-text)`,
          fontWeight: 400
        }
      },
      legend: {
        text: {
          fontSize: 11,
          fill: `var(--stat-text)`,
          fontWeight: 400
        }
      }
    }
  };

  return (
    <>
      {" "}
      <div className='revenue-map-chart' style={{ height: "300px" }}>
        {isDataAvailable ? (
          <>
            {" "}
            <div className='flex justify-between'>
              <div className='ml-4 mt-4 flex items-center legend'>
                {["FEMALE", "MALE", "Others"].map((legend) => (
                  <div
                    key={legend}
                    className='mr-2 flex items-center'
                    style={{ color: customGenColors[legend] }}
                  >
                    <div
                      className='w-3 h-3  mr-1'
                      style={{ backgroundColor: customGenColors[legend] }}
                    ></div>
                    <span>{legend}</span>
                  </div>
                ))}
              </div>
            </div>
            <ResponsiveBar
              data={graphData}
              keys={["FEMALE", "MALE", "Others"]}
              indexBy='age'
              margin={{ top: 10, right: 5, bottom: 40, left: 80 }}
              padding={0.3}
              maxValue={100}
              layout='horizontal'
              valueScale={{ type: "linear" }}
              colors={(e) => customGenColors[e.id]}
              borderColor={{
                from: "color",
                modifiers: [["darker", "1.6"]]
              }}
              axisTop={null}
              axisRight={null}
              axisBottom={{
                tickSize: 0,
                tickPadding: 0,
                tickRotation: 0,
                legend: "Age Percentage",
                legendPosition: "middle",
                legendOffset: 30,
                format: (value) => `${value}%`
              }}
              axisLeft={{
                tickSize: 0,
                tickPadding: 5,
                tickRotation: 0,
                legend: "Age",
                legendPosition: "middle",
                legendOffset: -70
              }}
              theme={theme}
              enableGridY={false}
              enableLabel={false}
              labelSkipWidth={12}
              labelSkipHeight={12}
              labelTextColor={{
                from: "color",
                modifiers: [["darker", 1.6]]
              }}
              legends={[]}
              role='application'
              barAriaLabel={(e) =>
                e.id + ": " + e.formattedValue + " in age: " + e.indexValue
              }
              tooltip={({ id, value }) => <strong className="text-color">{`${id}: ${value}`}%</strong>}
            />
          </>
        ) : (
          <div className='no-data-icon'>
            <img src={NoDataIcon} alt=''></img>
            <h1>{t("No Data Available")}</h1>
          </div>
        )}
      </div>
    </>
  );
};

export default AgeVsGenderChart;
